module.exports = "./img/desktop_logo.1631e59.png";